import { Title, Subtitle, Button } from '~components'
import { useStore, usePathValidation, useNavigate } from '~hooks'
import * as Styled from './styled'
import mobile from 'is-mobile'
import moment from 'moment'

function Difficulty() {
  const store = useStore()
  const navigate = useNavigate()
  const isMobile = mobile()
  const message = `Olá, preciso de ajuda para acessar a minha conta com o CPF ${store.cpf}. Poderia me ajudar?`

  usePathValidation(['cpf'])

  function handleClickWhatsapp() {
    window.open(
      `https://api.whatsapp.com/send/?phone=551141181843&text=${encodeURI(
        message,
      )}&app_absent=0`,
      '_blank',
    )
  }
  function handleClickCall() {
    if (mobile()) {
      window.open('tel:1130037182')
    }
  }
  function handleResetPassword() {
    navigate('/recuperar-senha-motorista', {
      state: { previousPath: '/entrar/dificuldade' },
    })
  }

  return (
    <>
      <Title>Dificuldades para entrar na Fretebras?</Title>
      <Subtitle>
        Você pode tentar entrar novamente às{' '}
        <Styled.Time>{moment().add(1, 'minutes').format('HH[h]mm')}</Styled.Time>,
        redefinir a sua senha ou falar com o nosso atendimento.
      </Subtitle>
      <Styled.Footer>
        <Button width="100%" onClick={handleResetPassword}>
          Redefinir minha senha
        </Button>
        <Styled.SecondaryButton
          color="secondary"
          width="100%"
          onClick={handleClickWhatsapp}
        >
          Atendimento pelo WhatsApp
        </Styled.SecondaryButton>
        {isMobile ? (
          <Styled.TertiaryButton onClick={handleClickCall}>
            Ligar no (11) 3003-7182
          </Styled.TertiaryButton>
        ) : (
          <Styled.SecondaryTypography>Ligar no (11) 3003-7182</Styled.SecondaryTypography>
        )}
      </Styled.Footer>
    </>
  )
}

export default Difficulty
